import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  connect() {
    $('#general-modal').modal('show');
  }

  disconnect() {
    if($('#close-modal').length != 0) {
      $('#general-modal').modal('hide');
    }
  }
}
